import * as React from 'react';
import { Label } from '@cian/ui-kit';
import * as style from './styles.css';
import { EType } from '../../types/newbuilding/reliableLabel';

interface IReliableLabelV2Props {
  onClick(event: React.MouseEvent<HTMLElement>): void;
  label: string;
  reliableType: EType;
}

export const ReliableLabelV2 = ({ onClick, reliableType, label }: IReliableLabelV2Props) => {
  const isReliable = reliableType === EType.Reliable;

  return (
    <div onClick={onClick} data-testid="ReliableLabel" className={style['label']}>
      <Label
        background={isReliable ? 'surface-positive-default' : 'theme-red'}
        color={isReliable ? 'theme-green' : 'text-inverted-default'}
      >
        {label}
      </Label>
    </div>
  );
};
